import jwtAuthAxios from "./auth/jwtAuth";

const centreServices = {};

centreServices.getCentres = async (params) => {
    const {data} = await jwtAuthAxios.get(`/centres${params || ''}`);
    return data;
};

centreServices.getCentreOptions = async (id) => {
    const {data} = await jwtAuthAxios.get(`/centres/${id}/options`);
    return data;
};

centreServices.searchByCompany = async () => {
  const { data } = await jwtAuthAxios.get('/centres/search_by_company');
  return data;
};

centreServices.getCentre = async (id, params = null) => {
    const { data } = await jwtAuthAxios.get(`/centres/${id}${params || ""}`);
    return data;
};

centreServices.createCentre = async (params, body) => {
    const { data } = await jwtAuthAxios.post(`/centres${params ?? ""}`, body);
    return data;
};

centreServices.saveCentre = async (id, params, body) => {
    const { data } = await jwtAuthAxios.put(`/centres/${id}${params ?? ""}`, body);
    return data;
};

// Que entiende HERE por esta direccion, sin guardar nada. La bodega se guarda recien
// cuando alguien elige uno de los candidatos.
centreServices.verifyAddress = async (address) => {
    const { data } = await jwtAuthAxios.get(`/centres/verify_address?address=${encodeURIComponent(address)}`);
    return data?.data || data;
};

centreServices.deleteCentre = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/centres/${id}`);
    return data;
};

export default centreServices;